import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PagoComponent } from './components/pago/pago.component';
import { CajaComponent } from './components/caja/caja.component';
import { EgresosComponent } from './components/egresos/egresos.component';
import { MenuComponent } from './components/menu/menu.component';
import { OpcionesComponent } from './components/opciones/opciones.component';
import { ProductosComponent } from './components/productos/productos.component';
import { RemesasComponent } from './components/remesas/remesas.component';


const routes: Routes = [
  
    {path: 'menu', component: MenuComponent},
    {path: 'caja', component: CajaComponent},
    {path: 'remesas', component: RemesasComponent},
    {path: 'egresos', component: EgresosComponent},
    {path: 'productos/:categoria', component: ProductosComponent},
    {path: 'pago', component: PagoComponent},
    {path: '', redirectTo: 'menu', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OpcionesRoutingModule { }
